import React from "react";
import SetupTab from "../pages/dm/components/setup/SetupTab";
import { portalDmApi } from "../pages/dm/dmApi";
import { PageHead } from "../pages/work/WorkUi";
import "../pages/dm/dm.css";

/** Portal: the company's own Digital Marketing setup checklist (accounts, Google, Meta, website and app). */
function TenantDmSetup() {
  return (
    <div className="dmp">
      <PageHead
        title="Marketing Setup"
        info="Every account and integration Tumma needs to run your digital marketing. Fill in and submit the items marked Client; Tumma completes and verifies the rest."
      />
      <SetupTab api={portalDmApi} />
    </div>
  );
}

export default TenantDmSetup;
